import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

const CONDITIONS = ["Mint", "Near Mint", "Excellent", "Good", "Fair", "Poor"];
const PKG_CONDITIONS = ["Mint", "Near Mint", "Good", "Damaged", "No Box"];

export { CONDITIONS, PKG_CONDITIONS };

export default function PurchaseFormFields({ form, setForm, showQuantity = true, showDate = false, showNotes = false }) {
  const update = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

  return (
    <div className="space-y-3">
      <div className={`grid gap-3 ${showDate ? "grid-cols-3" : "grid-cols-2"}`}>
        {showQuantity && (
          <div>
            <Label className="text-zinc-400 text-xs">Quantity</Label>
            <Input data-testid="add-quantity-input" type="number" min="1" value={form.quantity ?? 1} onChange={(e) => update("quantity", e.target.value)} className="bg-zinc-950 border-zinc-800 text-zinc-100 mt-1" />
          </div>
        )}
        <div>
          <Label className="text-zinc-400 text-xs">Purchase Price</Label>
          <Input data-testid="purchase-price-input" type="number" step="0.01" value={form.purchase_price ?? ""} onChange={(e) => update("purchase_price", e.target.value)} className="bg-zinc-950 border-zinc-800 text-zinc-100 mt-1" placeholder="$0.00" />
        </div>
        {showDate && (
          <div>
            <Label className="text-zinc-400 text-xs">Purchase Date</Label>
            <Input data-testid="purchase-date-input" type="date" value={form.purchase_date ?? ""} onChange={(e) => update("purchase_date", e.target.value)} className="bg-zinc-950 border-zinc-800 text-zinc-100 mt-1" />
          </div>
        )}
      </div>
      <div>
        <Label className="text-zinc-400 text-xs">Seller / Source</Label>
        <Input value={form.seller ?? ""} onChange={(e) => update("seller", e.target.value)} className="bg-zinc-950 border-zinc-800 text-zinc-100 mt-1" placeholder="e.g. eBay, local shop" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <Label className="text-zinc-400 text-xs">Condition</Label>
          <Select value={form.condition || "Mint"} onValueChange={(v) => update("condition", v)}>
            <SelectTrigger className="bg-zinc-950 border-zinc-800 text-zinc-300 mt-1"><SelectValue /></SelectTrigger>
            <SelectContent className="bg-zinc-900 border-zinc-800">
              {CONDITIONS.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label className="text-zinc-400 text-xs">Packaging</Label>
          <Select value={form.packaging_condition || "Mint"} onValueChange={(v) => update("packaging_condition", v)}>
            <SelectTrigger className="bg-zinc-950 border-zinc-800 text-zinc-300 mt-1"><SelectValue /></SelectTrigger>
            <SelectContent className="bg-zinc-900 border-zinc-800">
              {PKG_CONDITIONS.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      </div>
      <div>
        <Label className="text-zinc-400 text-xs">Storage Location</Label>
        <Input value={form.storage_location ?? ""} onChange={(e) => update("storage_location", e.target.value)} className="bg-zinc-950 border-zinc-800 text-zinc-100 mt-1" placeholder="e.g. Shelf A, Display Case 2" />
      </div>
      {showNotes && (
        <div>
          <Label className="text-zinc-400 text-xs">Notes</Label>
          <Input value={form.notes ?? ""} onChange={(e) => update("notes", e.target.value)} className="bg-zinc-950 border-zinc-800 text-zinc-100 mt-1" placeholder="Any notes about this purchase" />
        </div>
      )}
    </div>
  );
}
